module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ko_shikoku-73f72e555806c80ac6bb3e5226511164.jpg";